import { render, staticRenderFns } from "./AdminReportSalesByCategory.vue?vue&type=template&id=43888607"
import script from "./AdminReportSalesByCategory.vue?vue&type=script&lang=js"
export * from "./AdminReportSalesByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43888607')) {
      api.createRecord('43888607', component.options)
    } else {
      api.reload('43888607', component.options)
    }
    module.hot.accept("./AdminReportSalesByCategory.vue?vue&type=template&id=43888607", function () {
      api.rerender('43888607', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminReportSalesByCategory.vue"
export default component.exports